import { useEffect, useState } from "react";

import moment from 'moment-timezone';
import { Input as InputComponent } from "twyne-new.ui";

import DateTimePickerComponent from "components/form/DateTimePicker";
import { Select as SelectComponent, Async as SelectAsyncComponent } from "components/pure/form-fields/Select";
import appStore from 'stores/app';

const optionalize = fn => () => fn().then(options => ({ options }))

export function Select({ name, options, value, onChange, ...props }) {
  return <SelectComponent
    required
    name={name}
    options={options}
    value={value}
    onChange={option => onChange(option?.value)}
    clearable={false}
    {...props}
  />
}

export function SelectAsync({ name, loadOptions, value, onChange, ...props }) {
  return <SelectAsyncComponent
    required
    name={name}
    loadOptions={optionalize(loadOptions)}
    value={value}
    onChange={option => onChange(option?.value)}
    clearable={false}
    {...props}
  />
}

export function Input({ name, type, value, onChange, ...props }) {
  return <InputComponent
    className='border!'
    required
    name={name}
    type={type}
    value={value}
    onChange={event => onChange(event.target?.value)}
    {...props}
  />
}

export function DateTimePicker({ name, value, onChange, mask, ...props }) {
  const [date, setDate] = useState(undefined)

  useEffect(() => {
    if (value) {
      setDate(moment(value, 'YYYY-MM-DD').tz(appStore.timezone))
    }
  }, [value])

  const handleChange = date => {
    onChange(date?.format('YYYY-MM-DD'))
  }

  return <DateTimePickerComponent
    required
    meridiemSystem
    name={name}
    mask={mask}
    value={date}
    onChange={handleChange}
    openDirection="bottom"
    isOutsideRange={() => false}
    {...props}
  />
}

export function Boolean({ name, value, onChange, ...props }) {
  return <SelectComponent
    required
    name={name}
    options={[
      { label: "Yes", value: true },
      { label: "No", value: false },
    ]}
    value={value}
    onChange={option => onChange(option?.value)}
    clearable={false}
    {...props}
  />
}
